import { render } from "./ConfirmacaoVenda.vue?vue&type=template&id=270c837f&scoped=true"
import script from "./ConfirmacaoVenda.vue?vue&type=script&lang=js"
export * from "./ConfirmacaoVenda.vue?vue&type=script&lang=js"

import "./ConfirmacaoVenda.vue?vue&type=style&index=0&id=270c837f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270c837f"]])

export default __exports__